import { ICardResponseProps, RewardsBlock, useDictionary } from '@maverick/cms';
import { ComponentProps } from 'lib/component-props';
import { Field, withDatasourceCheck, useSitecoreContext, RichText, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

type CmsRewardsFormProps = ComponentProps & {
	rendering: {
		fields: {
			Title: Field<string>;
			'First Description'?: Field<string>;
			'Second Description'?: Field<string>;
			'Floating Placeholder': { value: boolean };
			'Signed Up Title'?: Field<string>;
			'Signed Up Text'?: Field<string>;
			'Signed Up Button'?: LinkField;
			'Welcome Back Title'?: Field<string>;
			'Welcome Back Text'?: Field<string>;
			'Welcome Back Button'?: LinkField;
		};
		params: {
			Variant?: string;
		};
	};
};

const CmsRewardsFormRendering = (props: CmsRewardsFormProps): JSX.Element => {
	const { sitecoreContext } = useSitecoreContext();
	const { dictionary } = useDictionary();

	const signedUpResponse: ICardResponseProps = {
		title: props?.rendering.fields['Signed Up Title']?.value ?? '',
		text: !!props?.rendering.fields['Signed Up Text']?.value ? (
			<RichText field={props?.rendering.fields['Signed Up Text']} />
		) : (
			<></>
		),
		button: {
			href: props.rendering.fields['Signed Up Button']?.value.href ?? '',
			label: props.rendering.fields['Signed Up Button']?.value.text ?? '',
			target: props.rendering.fields['Signed Up Button']?.value.target ?? '_blank',
		},
	};

	const welcomeBackResponse: ICardResponseProps = {
		title: props?.rendering.fields['Welcome Back Title']?.value ?? '',
		text: !!props?.rendering.fields['Welcome Back Text']?.value ? (
			<RichText field={props?.rendering.fields['Welcome Back Text']} />
		) : (
			<></>
		),
		button: {
			href: props.rendering.fields['Welcome Back Button']?.value.href ?? '',
			label: props.rendering.fields['Welcome Back Button']?.value.text ?? '',
			target: props.rendering.fields['Welcome Back Button']?.value.target ?? '_blank',
		},
	};

	return (
		<RewardsBlock
			variant={props?.params?.Variant === 'Secondary' ? 'secondary' : 'primary'}
			title={props?.rendering?.fields?.Title?.value}
			firstDescription={
				!!props?.rendering?.fields['First Description']?.value ? (
					<RichText field={props?.rendering?.fields['First Description']} />
				) : undefined
			}
			secondDescription={
				!!props?.rendering?.fields['Second Description']?.value ? (
					<RichText field={props?.rendering?.fields['Second Description']} />
				) : undefined
			}
			pageTitle={sitecoreContext.route?.displayName}
			floatingPlaceholder={false}
			dictionary={dictionary}
			signedUpResponse={signedUpResponse}
			welcomeBackResponse={welcomeBackResponse}
		/>
	);
};

export default withDatasourceCheck()<CmsRewardsFormProps>(CmsRewardsFormRendering);
